import React from "react";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, Tooltip } from "@mui/material";

interface DetailTabsProps {
  tab: 'details' | 'documents' | 'payments';
  tabsDisabled: boolean;
  onTabChange: (e: any, value: 'details' | 'documents' | 'payments') => void;
}

const DetailTabs: React.FC<DetailTabsProps> = ({ tab, tabsDisabled, onTabChange }) => {
  const { t } = useTranslation();

  const disabledTooltip = tabsDisabled
    ? t('reconciliation.managerStatement.detail.pageTexts.tabs.disabledTooltip')
    : '';

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor="primary" className="pt-2" variant="fullWidth">
        <Tab value="details" label={t("reconciliation.managerStatement.detail.pageTexts.tabs.details")} />
        <Tab
          value="documents"
          label={
            <Tooltip title={disabledTooltip} arrow classes={{ tooltip: 'tooltip' }}>
              <div className="w-100 h-100">{t("reconciliation.managerStatement.detail.pageTexts.tabs.documents")}</div>
            </Tooltip>
          }
          disabled={tabsDisabled}
          classes={{ disabled: 'pe-auto' }}
        />
        <Tab
          value="payments"
          label={
            <Tooltip title={disabledTooltip} arrow classes={{ tooltip: 'tooltip' }}>
              <div className="w-100 h-100">{t("reconciliation.managerStatement.detail.pageTexts.tabs.payments")}</div>
            </Tooltip>
          }
          disabled={tabsDisabled}
          classes={{ disabled: 'pe-auto' }}
        />
      </Tabs>
    </div>
  );
};

export default DetailTabs;
